import Api from '../utilities/api';

export default class JotformAccess {
    static getJotformToken = () => {
      return Api.get('https://api.triskele.tech/api/v1/jotform/create');
    };

}
